// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"506":"43b8636ac2bdf3c12140","954":"9b79e9ba64f6b6979f14"}[chunkId] + ".js";
};